
export default {
	props: [
		'error'
	],
	computed: {
		isDevelopment() {
			return process.env.NODE_ENV === 'development' || this.$nuxt?.isDev;
		}
	},
	methods: {
		getErrorMessage() {
			if (typeof this.error === 'string') {
				return this.error;
			}
			return this.error?.message || this.error?.toString() || 'Unknown error occurred';
		},
		getErrorLocation() {
			// Try to extract file and line information from error
			const message = this.getErrorMessage();
			const locationMatch = message.match(/(\w+\.(vue|js|ts))[:.](\d+)[:.](\d+)/);
			if (locationMatch) {
				return `${locationMatch[1]} at line ${locationMatch[3]}, column ${locationMatch[4]}`;
			}

			// Fallback: check if we have filename/line info in the error object
			if (this.error?.fileName && this.error?.lineNumber) {
				return `${this.error.fileName}:${this.error.lineNumber}`;
			}

			return 'Location information not available';
		},
		getUserAgent() {
			return typeof navigator !== 'undefined' ? navigator.userAgent : 'Server-side rendering';
		},
		formatError() {
			try {
				// Remove circular references and format nicely
				const errorObj = {};

				// Copy basic properties
				['name', 'message', 'statusCode', 'statusMessage', 'fileName', 'lineNumber', 'columnNumber'].forEach(prop => {
					if (this.error[prop] !== undefined) {
						errorObj[prop] = this.error[prop];
					}
				});

				// Add any additional enumerable properties
				Object.keys(this.error).forEach(key => {
					if (!errorObj.hasOwnProperty(key) && typeof this.error[key] !== 'function') {
						try {
							errorObj[key] = this.error[key];
						} catch (e) {
							errorObj[key] = '[Cannot serialize]';
						}
					}
				});

				return JSON.stringify(errorObj, null, 2);
			} catch (e) {
				return this.error?.toString() || 'Error object cannot be serialized';
			}
		}
	}
}
